<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="1" md="3" lg="3" class="alineacentro"></v-col>
      <v-col cols="10" md="6" lg="6" class="alineacentro">
        <v-card>
          <v-toolbar
            color="primary"
          >
            <v-toolbar-title class="textoblanco">CAPLP - Identifíquese</v-toolbar-title>
            <v-spacer/>
          </v-toolbar>
          <v-card-text class="alineacentro">
            <v-form>
              <v-text-field
                ref="username"
                v-model="username"
                :rules="[() => !!username || 'Este campo es requerido']"
                prepend-icon="mdi-account"
                label="Usuario"
                placeholder="Usuario"
                required
              />
              <v-text-field
                ref="password"
                v-model="password"
                :rules="[() => !!password || 'Este campo es requerido']"
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showPassword ? 'text' : 'password'"
                prepend-icon="mdi-lock"
                label="Clave"
                placeholder="*********"
                counter
                required
                @keydown.enter="login"
                @click:append="showPassword = !showPassword"
              />
            </v-form>
          </v-card-text>
          <v-divider class="mt-5"/>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineacentro">
                <br/>
                <v-btn
                  small
                  color="success"
                  @click="login">
                  Ingresar
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="1==2">
              <v-col cols="12" class="alineacentro">
                <v-btn
                  small
                  color="error"
                  @click="abreolvideclave">
                  Olvidé mi Clave
                </v-btn>
              </v-col>
            </v-row>
            <br/>
            <br/>
            <br/>
          </v-card-actions>
          <v-snackbar
            v-model="snackbar"
            :color="color"
            :top="true"
          >
            {{ errorMessages }}
            <v-btn
              dark
              flat
              @click="snackbar = false"
            >
              Close
            </v-btn>
          </v-snackbar>
        </v-card>
      </v-col>
      <v-col cols="1" md="3" lg="3" class="alineacentro"></v-col>
    </v-row>
    <v-dialog v-model="loading" full-width>
      <v-container
        fluid
        class="full-height"
        style="background-color: rgba(255, 255, 255, 0.5)"
      >
        <v-row
          align="center"
          justify="center"
          style="height: 100vh"
          no-gutters
          dense
        >
          <v-col class="elementocentrado">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
    <v-dialog v-model="dialogcambioclave" persistent max-width="700">
      <v-card>
        <v-card-title class="headline">
          Cambiar Clave de Usuario
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field
              ref="passwordnuevo"
              v-model="passwordnuevo"
              :rules="[rules.required]"
              :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
              :type="showPassword ? 'text' : 'password'"
              prepend-icon="mdi-lock"
              label="Nueva Clave"
              placeholder="*********"
              counter
              required
              @click:append="showPassword = !showPassword"
            />
            <v-text-field
              ref="passwordnuevorepetir"
              v-model="passwordnuevorepetir"
              :rules="[rules.required, rules.repetido]"
              :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
              :type="showPassword ? 'text' : 'password'"
              prepend-icon="mdi-lock"
              label="Repita Nueva Clave"
              placeholder="*********"
              counter
              required
              @keydown.enter="CambioClave"
              @click:append="showPassword = !showPassword"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="alineaderecha">
              <br />
              <v-btn color="green darken-1" text @click="CambioClave">
                Cambiar Clave
              </v-btn>
              <v-btn
                color="red darken-1"
                text
                @click="dialogcambioclave = false"
              >
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
          <br />
          <br />
          <br />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogolvidoclave" persistent max-width="480">
      <v-card>
        <v-card-title class="headline">
          Olvido de Clave de Usuario
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="alineaizquierda">
              {{ OCTituloAccion }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="alineaizquierda">
              <v-text-field
                v-model="olvidoclave.username"
                prepend-icon="mdi-account"
                label="Ingrese su Usuario"
                placeholder="Usuario"
                :disabled="olvidoclave.paso>0"
              />
            </v-col>
          </v-row>
          <v-row v-if="olvidoclave.paso===1">
            <v-col cols="12" md="8" lg="8" class="alineaizquierda">
              Ingrese el código que le fue enviado a su correo electrónico {{olvidoclave.correocodigo}}:
            </v-col>
            <v-col cols="12" md="4" lg="4" class="alineaizquierda">
              <v-text-field
                v-model="olvidoclave.codigomail"
                label="Código"
                placeholder="Código"
                type="number"
              />
            </v-col>
          </v-row>
          <v-row v-if="olvidoclave.paso===2">
            <v-col cols="12">
              <v-text-field
                v-model="olvidoclave.nuevopassword"
                :rules="[() => !!olvidoclave.nuevopassword || 'Este campo es requerido']"
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showPassword ? 'text' : 'password'"
                prepend-icon="mdi-lock"
                label="Nueva Clave"
                placeholder="*********"
                counter
                required
                @click:append="showPassword = !showPassword"
              />
            </v-col>
          </v-row>
          <v-row v-if="olvidoclave.paso===2">
            <v-col cols="12">
              <v-text-field
                v-model="olvidoclave.nuevopasswordrep"
                :rules="[rules.required, rules.repetidooc]"
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showPassword ? 'text' : 'password'"
                prepend-icon="mdi-lock"
                label="Nueva Clave"
                placeholder="*********"
                counter
                required
                @click:append="showPassword = !showPassword"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="alineaderecha">
              <br />
              <v-btn color="green darken-1" text @click="cambiarclaveOC">
                 {{ OCTituloBoton }}
              </v-btn>
              <v-btn color="red darken-1" text @click="dialogolvidoclave = false">
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
          <br />
          <br />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from "@/axios";
export default {
  data: function () {
    return {
      loading: false,
      username: '',
      password: '',
      errorMessages: 'Error al Identificarse',
      snackbar: false,
      color: 'general',
      showPassword: false,
      dialogcambioclave: false,
      passwordnuevo: '',
      passwordnuevorepetir: '',
      rules: {
          required: value => !!value || 'Este campo es requerido.',
          repetido: value => value===this.passwordnuevo || 'El campo Repetir Clave debe ser igual que el campo clave!!!',
          repetidooc: value => value===this.olvidoclave.nuevopassword || 'El campo Repetir Clave debe ser igual que el campo nueva clave!!!'
      },
      olvidoclave: {
        paso: 0,  //paso 0: inicio, paso 1: enviado el codigo al correo del matriculado, paso 2: comparado codigo, carga nueva clave
        idusuario: 0,
        username: '',
        correocodigo: '',
        codigomail: '',
        codigomailenviado: '',
        expira: '',
        nuevopassword: '',
        nuevopasswordrep: ''
      },
      OCTituloBoton: 'Enviar Código',
      OCTituloAccion: 'Ingrese su usuario y presione Enviar Código, se le enviará un código único, para cambiar su clave, al correo registrado en el CAPLP.'
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome= home!=null ? home : false;
      this.dialogmensaje = true;
    },
    login: function () {
      this.loading=true;
      let username = this.username
      let password = this.password
      this.$store.dispatch('login', { username, password }).then(() => { 
          if (localStorage.getItem('idestado')==='7') { 
            this.abrecambioclave();
          } else {
            //if(localStorage.getItem('rolesusuario').includes(6) || localStorage.getItem('rolesusuario').includes(7)) {
            if(localStorage.getItem('rolesusuario').includes(7)) {
              if(localStorage.getItem('rolesusuario').includes(1) || localStorage.getItem('rolesusuario').includes(2) || localStorage.getItem('rolesusuario').includes(3) || localStorage.getItem('rolesusuario').includes(4) || localStorage.getItem('rolesusuario').includes(5) || localStorage.getItem('rolesusuario').includes(8) || localStorage.getItem('rolesusuario').includes(9) || localStorage.getItem('rolesusuario').includes(10)) {
                this.$router.push('/home');
              }else{
                this.$router.push('/micaplp');
              }
            }else{
              this.$router.push('/home');
            }
          }
      }).catch(err => {
        console.log(err)
        this.errorMessages= localStorage.getItem('mensaje');
        this.snackbar = true;
        this.loading=false;
      })
    },
    abrecambioclave: function () {
      this.loading=false;
      this.dialogcambioclave=true;
    },
    CambioClave () {
      this.loading=true;
      const seguusuariocpass = JSON.stringify({idusuario: null, usuario: this.username, nuevopassword: this.passwordnuevo, temporal: true});
      axios.post("usuario/cambiarpassword", seguusuariocpass, {
        headers: {
            "Content-Type": "application/json",
        },
      }).then((result) => {
        if (result.data.resultado===0) {
            this.dialogcambioclave = false;
            this.loading=false;
            this.MostrarMensaje('Felicitaciones!!!', 'Cambio de clave exitoso, ingrese al sistema con la nueva clave.',false);
        } else {
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadoMensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    abreolvideclave () {
      this.olvidoclave= {
        paso: 0,
        idusuario: 0,
        username: '',
        correocodigo: '',
        codigomail: '',
        codigomailenviado: '',
        expira: '',
        nuevopassword: '',
        nuevopasswordrep: ''
      }
      this.dialogolvidoclave= true;
    },
    cambiarclaveOC () {
      if(this.olvidoclave.paso===0) {
        if(this.olvidoclave.username.length>3) {
          this.loading=true;
          const param = JSON.stringify(this.olvidoclave);
          axios.post("usuario/olvidopassword", param, { headers: { "Content-Type": "application/json"}}).then((result) => {
            if (result.data.resultado===0) {
                this.olvidoclave.paso=1;
                this.olvidoclave.correocodigo= result.data.datos.correocodigo;
                this.olvidoclave.codigomailenviado= result.data.datos.codigomail;
                this.olvidoclave.expira= result.data.datos.expira;
                this.OCTituloBoton='Continuar';
                this.OCTituloAccion='Ingrese el código que se le ha enviado por correo, el mismo expira en 5 minutos.';
                this.loading=false;
                //this.MostrarMensaje('Felicitaciones!!!', 'Cambio de clave exitoso, ingrese al sistema con la nueva clave.',false);
            } else {
                this.loading = false;
                this.MostrarMensaje("Error", result.data.resultadoMensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje("Error", error, false);
          });
        }else{
          this.MostrarMensaje('Error', 'Debe ingresar su usuario!', false);
        }
      }else if (this.olvidoclave.paso===1) {
        if(this.olvidoclave.codigomail.length>0 && this.olvidoclave.codigomail.length<5) {
          if(this.olvidoclave.codigomail===this.olvidoclave.codigomailenviado) {
            var exp= new Date(this.olvidoclave.expira);
            var act= new Date();
            if(act>=exp) {
              this.olvidoclave.paso=2;
              this.OCTituloBoton='Cambiar Clave';
              this.OCTituloAccion='Ingrese la nueva clave y repita la misma para terminar el cambio de clave.';
            }else{
              this.dialogolvidoclave= false;
              this.MostrarMensaje('Código Vencido', 'El código ingresado ha expirado, debe volver a repetir la operación!', false);
            }
          }else{
            this.MostrarMensaje('Código Equivocado', 'Debe ingresar el código que se le envió via correo electrónico!', false);
          }
        }else{
          this.MostrarMensaje('Error', 'Debe ingresar un código válido!', false);
        }
      }else if (this.olvidoclave.paso===2) {
        if(this.olvidoclave.nuevopassword.length>=8) {
          if(this.olvidoclave.nuevopassword===this.olvidoclave.nuevopasswordrep) {
            this.loading=true;
            const seguusuariocpass = JSON.stringify({idusuario: this.olvidoclave.idusuario, usuario: this.olvidoclave.username, nuevopassword: this.olvidoclave.nuevopassword, temporal: true});
            axios.post("usuario/cambiarpassword", seguusuariocpass, { headers: { "Content-Type": "application/json" }}).then((result) => {
              if (result.data.resultado===0) {
                  this.dialogolvidoclave = false;
                  this.loading=false;
                  this.MostrarMensaje('Felicitaciones!!!', 'Cambio de clave exitoso, ingrese al sistema con la nueva clave.',false);
              } else {
                  this.loading = false;
                  this.MostrarMensaje("Error", result.data.resultadoMensaje, false);
              }
            }).catch((error) => {
              this.loading = false;
              this.MostrarMensaje("Error", error, false);
            });
          }else{
            this.MostrarMensaje("Error", 'La nueva clave no es igual a la repetición!', false);
          }
        }else{
          this.MostrarMensaje("Error", 'Ingrese una clave de al menos 8 dígitos!', false);
        }
      }
    }
  },
  metaInfo () {
    return {
      title: 'CAPLP | Colegio de Abogados y Procuradores de La Pampa'
    }
  }
}
</script>
<style>
  .textocentrado {
    text-align: center !important;
  }
  .elementocentrado {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .DatosMatriculado {
      font-family: Verdana;
      font-size: 16pt !important;
  }

  .alineaizquierda {
    text-align: left !important;
  }
  .alineacentro {
    text-align: center !important;
  }
  .alineaderecha {
    text-align: right !important;
  }
  .textoblanco {
    color: rgba(255, 255, 255, 0.7);
  }
  .elementocentrado{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ocupa30{
    width: 30%;
  }

  .ocupa50{
    width: 50%;
  }

  .ocupa75{
    width: 75%;
  }

  .ocupa90{
    width: 90%;
  }
</style>